import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass an array of strings as `lines`.
export const KineticText = ({ lines, className = "", delay = 0, stagger = 0.12, as = "h1" }) => {
  const Tag = motion[as] || motion.h1;
  return (
    <Tag className={className} data-testid="kinetic-heading">
      {lines.map((line, i) => (
        <span className="line-mask" key={`${i}-${line}`}>
          <motion.span
            style={{ display: "block", willChange: "transform" }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.1,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};
